<template>
  <div class="home">
    <pc-header activeIndex="home"></pc-header>
    <div class="container pt-4">
      <div class="row mb-5 ">
        <div class="col-12 col-sm-6 ">

          <h1 class="mt-1 h1--home">
            Time Travel Debugging for Python
          </h1>
          <div class="mb-4">
            Ever dreamed to run your code in reverse direction?

            Now this is possible.

            Inspect variables, call graphs and execution branches on recorded trace.
          </div>


          <div class="get-started mt-5 d-flex align-items-center justify-content-center justify-content-md-start">
            <a :href="interactiveDemoLink" class="get-started__link ">
              <div class="get-started__button">
                Interactive Demo
              </div>
            </a>

          </div>

          <div class="text-secondary ml-0 mt-2 ml-sm-0 mb-1 text-center text-sm-left">or</div>
          <div class="ml-0 mt-1 ml-sm-0 mb-5 mb-sm-4 text-center text-sm-left"><a :href="webAppLink" target="_blank">  Go to the App</a></div>

        </div>
        <div class="col-12 col-sm-6 ">
          <div class="video__container mb-4">
            <iframe
                class="youtube--iframe"
                width="910"
                height="540"
                src="https://www.youtube.com/embed/zmvVEyyIH9g" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
<!--    <pc-features-highlight/>-->
    <pytrace-features-carousel/>
    <a name="get-started"></a>
    <div class="container">
    <pc-quick-start />
    </div>

    <pc-footer/>
  </div>

</template>

<script>
  // @ is an alias to /src
  import PcHeader from '@/components/pc-header.component'
  import PcFooter from '../views/PcFooter'
  import PcQuickStart from '../views/documentation/quick-start.component'
  import config from '../config'
  import PytraceFeaturesCarousel from './PytraceFeaturesCarousel'

  export default {
    name: 'home',
    data () {
      return {
        webAppLink: config.webapp_link,

      }
    },
    computed: {
      interactiveDemoLink () {
        return this.webAppLink + '?open=v0.1-interactive-demo'
      },
    },
    components: {
      PytraceFeaturesCarousel,
      PcQuickStart,
      PcFooter,
      PcHeader,

    },
    methods: {
    },
  }
</script>
<style scoped>
  .h1--home {
    font-size: 1.3em;
  }

  .get-started__button {
    background: linear-gradient(123.71deg, #4E9B00 2.01%, #019C23 100%);
    box-shadow: -1px 1px 6px rgba(9, 157, 32, 0.22);
    /*box-shadow: -1px 1px px rgba(138, 150, 162, 0.8);*/
    border-radius: 4px;
    padding: .8em;
    width: 200px;
    text-align: center;
    font-style: normal;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .get-started__button:hover {
    background: linear-gradient(123.71deg, #448700 2.01%, #019C23 100%);
    box-shadow: -1px 2px 10px rgba(9, 157, 32, 0.40);

  }

  .video__container {
    position: relative;
    padding-bottom: 57.35%; /* 16:9 */
    padding-top: 25px;
    height: 0;
  }

  .video__container .youtube--iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .get-started__link {
    text-decoration: none;
  }

</style>
